import { Formik } from "formik";
import {
  MelcoModelsGenericList1MelcoModelsUserProductListItem,
  MelcoModelsUserProductListItem,
} from "melco-shared-logic";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";
import { DirtyFormPrompt } from "../../form/DirtyFormPrompt";
import { DisplayUserDetailForm } from "./DisplayUserDetailForm";

type UserDetailFormProps = {
  userProducts: MelcoModelsGenericList1MelcoModelsUserProductListItem;

  referencesProductDrawer: DrawerType;
  selectedUserId: string;
  onCloseProductsDrawer: () => void;

  refetch: any;
};

type DesignCollectionDetailFormValueType = {
  product_list: MelcoModelsUserProductListItem[];
};

export const productToInitialValues = (
  product: MelcoModelsGenericList1MelcoModelsUserProductListItem
) => {
  const { list } = product;

  const initialValues: DesignCollectionDetailFormValueType = {
    product_list: list ?? [],
  };

  return initialValues;
};
export const UserDetailForm: React.FC<UserDetailFormProps> = ({
  refetch,
  selectedUserId,
  userProducts,
  onCloseProductsDrawer,
  referencesProductDrawer,
}) => {
  const initialValues = productToInitialValues(userProducts);

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={() => {}}
      enableReinitialize
    >
      <DirtyFormPrompt>
        <DisplayUserDetailForm
          //userProducts={userProducts}
          refetch={refetch}
          onCloseProductsDrawer={onCloseProductsDrawer}
          referencesProductDrawer={referencesProductDrawer}
          selectedUserId={selectedUserId}
        />
      </DirtyFormPrompt>
    </Formik>
  );
};
